<template>
  <div class="box box-solid bg-dark">
    <div class="box-header no-border">
      <h4 class="box-title">Control</h4>
    </div>
    <div class="box-body bg-dark text-center">
      <template>
        <p class="mt-4" v-show="next">
          <button
            @click.prevent="nextTask"
            class="btn pointer-cursor text-white btn-success btn-block"
          >
            NEXT TASK <i class="fa fa-arrow-right"></i>
          </button>
        </p>
      </template>
      <template>
        <h1 v-show="!next">
          <span :id="`ten-countdown`" class="text-success"></span> For Next Task
          <i class="fa fa-time"></i>
        </h1>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ad-control",
  data() {
    return {
      next: false
    };
  },
  mounted() {
    this.setTimer(`ten-countdown`, 1, 0);
  },
  methods: {
    nextTask() {
      this.$emit("next");
      this.next = false;
      this.setTimer(`ten-countdown`, 1, 0);
    },
    setTimer(elementName, minutes, seconds) {
      let local = this;
      let state = this;
      let element, endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? "0" + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          local.next = true;
          local.$store.dispatch("adView/completedTask");
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          element.innerHTML =
            (hours ? hours + ":" + twoDigits(mins) : mins) +
            ":" +
            twoDigits(time.getUTCSeconds());
          state.counter = setTimeout(
            updateTimer,
            time.getUTCMilliseconds() + 500
          );
        }
      }

      element = document.getElementById(elementName);
      endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
      updateTimer();
    }
  }
};
</script>
